module.exports = __webpack_public_path__ + "static/media/top-time-dark-icon.deb299ef.svg";